/** Coordinates deferred below-fold section mounting (hash nav + scroll affordance). */

type BelowFoldLoadListener = () => void;

let loadAllBelowFoldSections = false;
const listeners = new Set<BelowFoldLoadListener>();

function emit(): void {
	for (const listener of listeners) {
		listener();
	}
}

export function getLoadAllBelowFoldSections(): boolean {
	return loadAllBelowFoldSections;
}

export function requestLoadAllBelowFoldSections(): void {
	if (loadAllBelowFoldSections) {
		return;
	}
	loadAllBelowFoldSections = true;
	emit();
}

export function subscribeBelowFoldLoad(
	listener: BelowFoldLoadListener,
): () => void {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
}
